import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const pagosSlice = createSlice({
  name: 'pagos',
  initialState: {
    page: -1,
    count: 0,
    rows: []
  },
  reducers: {
    setPagos: (state, action) => {
      state.page = action.payload.page;
      state.count = action.payload.count;
      state.rows = action.payload.rows;
    }
  }
});

export const { setPagos } = pagosSlice.actions;

// Action Creators
export const getPagos = (comunidadId, anno, mes, page, size) => async (dispatch, getState) => {
  let offset = page * size;
  let item = LocalCache.get(`KEY:pagos&comunidad=${comunidadId}&ano=${anno}&mes=${mes}&offset=${offset}`);
  if (item) {
    dispatch(setPagos(item));
  } else {
    try {
      const response = await API.get('ePlat', `/pagos?comunidad=${comunidadId}&ano=${anno}&mes=${mes}&offset=${offset}&size=${size}`);
      let pagos = { page: response.count > 0 ? page : -1, count: response.count, rows: response.rows };
      dispatch(setPagos(pagos));
      LocalCache.put(`KEY:pagos&comunidad=${comunidadId}&ano=${anno}&mes=${mes}&offset=${offset}`, pagos);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getPagos()', error);
    }
  }
};

export default pagosSlice.reducer;
